// HEIC (iPhone) images can't be read by the print service or by Chrome and Firefox, and they can arrive
// with any extension and file.type, e.g. "photo.jpeg" as image/jpeg. They are recognised by their content
// so that they can be refused.

const heicBrands = new Set(["heic", "heix", "hevc", "heim", "heis", "mif1", "msf1"]);

// An ISO media file starts with the size of its first box, "ftyp" and the major brand.
export async function isHeic(file) {
  const head = new Uint8Array(await file.slice(0, 12).arrayBuffer());
  if (head.length < 12) return false;
  const text = (from, to) => String.fromCharCode(...head.subarray(from, to));
  return text(4, 8) === "ftyp" && heicBrands.has(text(8, 12));
}
